import { useEffect, useState } from "react";
import { getQueue } from "@/api/jobs";
import type { QueueSnapshot } from "@/api/jobs";

export function useQueue(intervalMs = 3000): { data: QueueSnapshot | null; error: string | null } {
  const [data, setData] = useState<QueueSnapshot | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const q = await getQueue();
        if (!cancelled) { setData(q); setError(null); }
      } catch (e: any) {
        if (!cancelled) setError(e.message);
      }
    }
    load();
    const t = setInterval(load, intervalMs);
    return () => { cancelled = true; clearInterval(t); };
  }, [intervalMs]);
  return { data, error };
}
